import { useCallback } from 'react';
import type { Props } from './types';

const useLogic = <T extends string>(props: Props<T>) => {
    const onChange = useCallback((event: any) => props.onChange(event.target.value), [props.onChange]);
    return { onChange };
};

export default useLogic;
